export default "__VITE_ASSET__CJv8QNWE__"